<template>
    <div>
        <div class="page-head">
            <a-icon @click="$router.go(-1)" type="left-square" theme="filled"/>
            <a-breadcrumb>
                <a-breadcrumb-item>首页</a-breadcrumb-item>
                <a-breadcrumb-item><a href="javascript:;">客资管理</a></a-breadcrumb-item>
                <a-breadcrumb-item><a href="javascript:;">客户列表</a></a-breadcrumb-item>
            </a-breadcrumb>
        </div>

        <div class="clue-search">
            <div class="left">
                 <!-- 日期 -->
                <a-range-picker :locale="locale" @change="ondateChange" placeholder="请选择日期范围" style="margin-right:12px"/>

                <!-- 标签 -->
                <a-select style="width: 120px" allowClear @change="zfhandleChange" placeholder="支付状态" :showArrow="show">
                    <a-select-option mode="multiple" v-for="(option,x) in zfoption" :key="x" :value="option.id">
                        {{option.title}}
                    </a-select-option>
                </a-select>
                <a-select style="width: 120px" allowClear @change="typehandleChange" placeholder="物流状态" :showArrow="show">
                    <a-select-option mode="multiple" v-for="(option,x) in typeoption" :key="x" :value="option.id">
                        {{option.title}}
                    </a-select-option>
                </a-select>
                <a-select style="width: 120px" allowClear @change="jhhandleChange" placeholder="激活状态" :showArrow="show">
                    <a-select-option mode="multiple" v-for="(option,x) in jhoption" :key="x" :value="option.id">
                        {{option.title}}
                    </a-select-option>
                </a-select>
            </div>
            <!-- 来源 -->

            <div class="right">
                <a-input-search
                    placeholder="关键字（名称/手机）"
                    enter-button="查询"
                    @search="onSearch"
                    v-model="searchtext"
                    >
                </a-input-search>
            </div>
             
        </div>

        <div class="data-list">
            <a-spin :spinning="tablespinning">
                <a-table  rowKey="usid" :scroll="{x: 1100}" :pagination="pageshow" :columns="columns" :data-source="data">
                    <router-link slot="name" slot-scope="text,record" :to="{path:'customdetail',query: {id:record.id}}" >
                        {{ text }}
                    </router-link>

                     <span slot="status" slot-scope="text">
                        <a-tag v-if="text=='未发货'" color="orange">{{text}}</a-tag>
                        <a-tag v-if="text=='已发货'" color="green">{{text}}</a-tag>
                        <a-tag v-if="text=='已签收'" color="blue">{{text}}</a-tag>
                        <a-tag v-if="text=='已激活'" color="green">{{text}}</a-tag>
                    </span>

                    <span slot="pay" slot-scope="text">
                        <a-tag v-if="text==0" color="orange">未支付</a-tag>
                        <a-tag v-if="text==1" color="green">已支付</a-tag>
                        <a-tag v-if="text==3" color="blue">已退款</a-tag>
                    </span>

                    <span slot="jh" slot-scope="text">
                        <a-tag v-if="text=='未激活'" color="orange">{{text}}</a-tag>
                        <a-tag v-if="text=='已激活'" color="green">{{text}}</a-tag>
                    </span>

                    <span slot="sources" slot-scope="text">
                      <span v-if="text==1">电话</span>
                      <span v-if="text==2">百度</span>
                    </span>
                    <span slot="sex" slot-scope="text">
                      <span v-if="text==1">男</span>
                      <span v-if="text==2">女</span>
                    </span>
                     <span slot="date" slot-scope="text">
                        <span v-if="text">{{text | formatDate }}</span>
                        <span v-else>--</span>
                    </span>

                    <span slot="address" slot-scope="text,record">
                        {{record.province}}{{record.city}}{{record.area}}{{text}}
                    </span>
                    
                    <a style="color:#1890ff;display:flex;align-items: center;" slot="phone" slot-scope="text,record" @click="totel(record.usxsid)">
                        <a-icon type="phone" theme="filled"/> 
                        <span v-if="pwdtype==1" style="margin-left:3px">{{text}}</span> 
                        <span v-if="pwdtype==2" style="margin-left:3px">{{text | topwd}}</span>
                        <span v-if="pwdtype==3" style="margin-left:3px">{{text | tomd5}}</span>
                    </a>
                    <span slot="action" slot-scope="text,record">
                        <a href="javascript:;"  @click="copy($event,record.invitationlink)" style="margin-right:12px"><a-icon type="copy" /> 复制链接</a>
                        <router-link :to="{path:'customdetail',query: {id:record.usxsid,kid:record.usid}}"><a-icon type="profile"/> 详情</router-link>
                    </span>
                </a-table>

                <div style="padding-top:30px;width: auto;display: flex;align-items: center;justify-content: flex-start;margin: 15px 12px 12px;">
                    <div class="page-total">总计：{{pagination.total}}条 / {{totalpage}}页</div>
                    <a-pagination
                    show-size-changer
                    :default-current="1"
                    :page-size-options="pageSizeOptions"
                    :total="pagination.total"
                    :defaultPageSize="10"
                    @change="handleTableChange"
                    @showSizeChange="onShowSizeChange"
                    >
                        <template slot="buildOptionText" slot-scope="props">
                            <span>{{ props.value }}条/页</span>
                        </template>

                    </a-pagination>
                </div>
            </a-spin>
        </div>

    </div>
    
</template>

<script>
import {formatDate} from '../../utils/formate.js'
import locale from 'ant-design-vue/es/date-picker/locale/zh_CN';
import Clipboard from 'Clipboard' 
import moment from 'moment'
import md5 from 'js-md5'
const columns = [
    {title: 'ID',dataIndex: 'usid',key: 'usid',fixed: 'left',width:80},
    {title: '姓名',dataIndex: 'username',key: 'username',scopedSlots: { customRender: 'name' },width:120},
    {title: '电话',dataIndex: 'telephone',key: 'telephone',scopedSlots: { customRender: 'phone' },width:'160px'},
    // {title: '地址',dataIndex: 'address',key: 'address',scopedSlots: { customRender: 'address' }},
    {title: '线索来源',dataIndex: 'sources',key: 'sources',scopedSlots: { customRender: 'sources' },width:120},
    {title: '付款状态',dataIndex: 'state_pay',key: 'state_pay',scopedSlots: { customRender: 'pay' },width:100},
    
    {title: '物流状态',dataIndex: 'state_wl',key: 'state_wl',scopedSlots: { customRender: 'status' },width:100},
    {title: '激活状态',dataIndex: 'state_jh',key: 'state_jh',scopedSlots: { customRender: 'jh' },width:100},
    {title: '性别',dataIndex: 'sex',key: 'sex',scopedSlots: { customRender: 'sex' },width:90},
    // {title: '出生日期',dataIndex: 'birthday',key: 'birthday',scopedSlots: { customRender: 'date' }},
    {title: '备注',dataIndex: 'remarks',key: 'remarks',width:260},
    {title: '跟进时间',dataIndex: 'updatetime',key: 'updatetime',scopedSlots: { customRender: 'date' },width:120},

    {title: '操作',key: 'action',scopedSlots: { customRender: 'action' },fixed: 'right',width:200},
];
export default {
     filters: {
      //年-月-日
      formatDate (time) {
        time = time * 1000
        let date = new Date(time)
        console.log(new Date(time))
        return formatDate (date, 'yyyy-MM-dd')
      },
      topwd (value) {
            const start = value.slice(0, 3)
            const end = value.slice(-4)
            return `${start}****${end}`
        },
        tomd5(value){
            const text=md5(value)
            const text2=text.slice(0,10);
            return text2
        }
    },
    data(){
        return{
            locale,
            show:true,
            zfoption:[{title:"全部",id:""},{title:"未支付",id:"0"},{title:"已支付",id:"1"},{title:"已退款",id:"3"}],
            jhoption:[{title:"全部",id:""},{title:"已激活",id:"1"},{title:"未激活",id:"2"}],
            typeoption:[{title:"全部",id:""},{title:"未发货",id:"0"},{title:"已发货",id:"1"},{title:"已签收",id:"2"},{title:"拒收",id:"3"}],
            searchtext:"",
            tstext:"",
            tablespinning:true,
            tablex:"100%",
            windowHeight: document.documentElement.clientHeight,   //实时屏幕高度
            columns,
            data:[],
            pagination:{
                total:20
            },
            totalpage:2,
            size:10,
            pageshow:false,
            currentpagination:"",
            pageSizeOptions:['10','20','30','40','100','200'],

            editvisible:false,
            numshow:true,
            // gjvisible:false,
            form: this.$form.createForm(this, { name: 'coordinated' }),

            starttime:"",
            endtime:"",

            pwdtype:"",

            state_pay:"",
            state_jh:"",
            state_wl:"",
        }
    },
    mounted(){
        this.fetch()
        this.pwdtype=localStorage.getItem('pwdtype')
    },
    methods:{
        copy(e, text){
            const clipboard = new Clipboard(e.target, { text: () => text })
            clipboard.on('success', e => {
                this.$message.success('复制成功' )
                // 释放内存
                clipboard.off('error')
                clipboard.off('success')
                clipboard.destroy()
            })
            clipboard.on('error', e => {
                // 不支持复制
                 this.$message.warning('该浏览器不支持自动复制' )
                // 释放内存
                clipboard.off('error')
                clipboard.off('success')
                clipboard.destroy()
            })
            clipboard.onClick(e)
        },
        // 来源筛选
        lyhandleChange(){

        },

        // 标签筛选
        zfhandleChange(value){
            this.currentpage=1
            this.state_pay=value
            this.fetch()

        },
        typehandleChange(value){
            this.state_wl=value
            this.currentpage=1
            this.fetch()

        },
        jhhandleChange(value){
            this.state_jh=value
            this.currentpage=1
            this.fetch()

        },

        // 号码查询
        handleserach(){

        },
        onSearch(){
            this.fetch()
        },

        // 分页
        handleTableChange(pageNumber) {
            this.currentpage=pageNumber
            this.fetch();
        },
        onShowSizeChange(current,pageSize){
            this.size=pageSize
            this.page=1
            this.fetch();
        },

        // 数据
        fetch(){
            this.$axios.post('/api/user/userlist',{
                pagesize: this.size,
                page:this.currentpage,
                search:this.searchtext,
                endtime:this.endtime,
                starttime:this.starttime,
                state_wl:this.state_wl,
                state_jh:this.state_jh,
                state_pay:this.state_pay

            },{
                headers: {
                    "token":localStorage.getItem('token'),
                }
            }).then((res)=>{
                if(res.data.code==200){
                    this.tablespinning=false
                    const pagination = { ...this.pagination };
                    pagination.total = res.data.data.total;
                    pagination.pageSize=this.size
                    this.data=res.data.data.data
                    this.pagination = pagination;
                    this.totalpage=Math.ceil(res.data.data.total/this.size)
                }else{
                    this.$message.error(res.data.msg); 
                }
                
            })
        },

        // 外呼
        totel(id){
             this.$axios.get('https://fxbkfluyin.13524.net/call_do1.php?usxsid='+id,{},{
                headers: {
                    "token":localStorage.getItem('token'),
                },
            }).then((res)=>{
                if(res.data.code==100){
                    this.$message.success(res.data.msg); 
                }else{
                    this.$message.warning(res.data.msg); 
                }
            })
        },
    
        ondateChange(date, dateString) {
            this.starttime=moment(dateString[0]+' 00:00:01').unix()
            this.endtime=moment(dateString[1]+' 23:59:59').unix()
            this.fetch()
        },


    }
}
</script>


// WEBPACK FOOTER //
// src/components/resources/customlist.vue